import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Auth } from '../auth/auth';

/**
 * Auth Interceptor
 * Añade el token de autenticación a todas las peticiones HTTP
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const token = auth.getToken();

  // Si hay token y la petición va a la API, añadir el header Authorization
  const sendReq = (r: typeof req) =>
    next(r).pipe(
      catchError((err) => {
        // Si es 401 y no es una petición de login, limpiar token local
        const isAuthLogin = r.url.includes('/auth/login') || r.url.includes('/ms/login');
        if (err && err.status === 401 && !isAuthLogin) {
          try {
            auth.clearLocalSession();
            // Redireccionar a login si no estamos ya en esa página
            if (!window.location.pathname.includes('/login')) {
              window.location.href = '/login';
            }
          } catch {
            // ignore
          }
        }
        return throwError(() => err);
      })
    );

  if (token && req.url.includes('/api/')) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return sendReq(clonedRequest);
  }

  return sendReq(req);
};
